import { useState, useEffect } from 'react';
import { apiClient } from '../../services/api/apiClient';
import { IUserStats } from '../../types/profile.types';

interface UseUserStatsResult {
  stats: IUserStats | null;
  loading: boolean;
  error: string | null;
}

export const useUserStats = (): UseUserStatsResult => {
  const [stats, setStats] = useState<IUserStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiClient
      .get<{ status: string; data: IUserStats }>('/trips/statistics')
      .then((res) => setStats(res.data.data))
      .catch((err) =>
        setError(err.response?.data?.message || 'Failed to load stats')
      )
      .finally(() => setLoading(false));
  }, []);

  return { stats, loading, error };
};
